import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';

const STEPS = [
  { id:1,  label:'Account' },
  { id:2,  label:'Access fee' },
  { id:3,  label:'English video' },
  { id:4,  label:'Bio & Quals' },
  { id:5,  label:'Experience' },
  { id:6,  label:'Subjects' },
  { id:7,  label:'ID Upload' },
  { id:8,  label:'DBS' },
  { id:9,  label:'References' },
  { id:10, label:'Availability' },
  { id:11, label:'Submit' },
];

const DAYS  = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
const TIMES = ['07:00','08:00','09:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00','22:00'];

const LEVELS = [
  { id:1, name:'KS1 (Ages 5-7)',       group:'Primary' },
  { id:2, name:'KS2 (Ages 7-11)',      group:'Primary' },
  { id:3, name:'KS3 (Ages 11-14)',     group:'Secondary' },
  { id:4, name:'GCSE (Ages 14-16)',    group:'Secondary' },
  { id:5, name:'A-Level / AS-Level',   group:'Sixth Form' },
  { id:7, name:'Adult Learning',       group:'Adult' },
];

function Stepper({ current }) {
  return (
    <div style={{display:'flex',overflowX:'auto',gap:0,marginBottom:36,padding:'4px 0'}}>
      {STEPS.map((s,i)=>(
        <div key={s.id} style={{display:'flex',alignItems:'center',flex:1,minWidth:44}}>
          <div style={{display:'flex',flexDirection:'column',alignItems:'center',flex:1}}>
            <div style={{
              width:26,height:26,borderRadius:'50%',display:'flex',alignItems:'center',justifyContent:'center',
              fontWeight:800,fontSize:'0.68rem',flexShrink:0,
              background: s.id < current ? '#22c97f' : s.id===current ? '#052e1c' : '#deeee7',
              color: s.id < current || s.id===current ? '#fff' : '#7a9a8a',
              boxShadow: s.id===current ? '0 0 0 4px rgba(34,201,127,0.2)' : 'none',
            }}>
              {s.id < current ? '✓' : s.id}
            </div>
            <span style={{fontSize:'0.55rem',fontWeight:600,color:s.id===current?'var(--green-700)':'var(--ink-300)',marginTop:4,textAlign:'center',whiteSpace:'nowrap'}}>{s.label}</span>
          </div>
          {i < STEPS.length-1 && (
            <div style={{height:2,flex:1,background:s.id<current?'#22c97f':'#deeee7',margin:'0 1px',marginBottom:18}}/>
          )}
        </div>
      ))}
    </div>
  );
}

export default function TutorOnboarding() {
  const navigate = useNavigate();
  const [step, setStep]       = useState(2);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving]   = useState(false);
  const [error, setError]     = useState('');

  // Step 3 - English video
  const [englishVideo, setEnglishVideo] = useState(null);

  // Step 4 - Bio & Quals
  const [bio, setBio]              = useState('');
  const [qualifications, setQuals] = useState('');
  const [eduDocs, setEduDocs]      = useState([]);

  // Step 5 - Work Experience
  const [workExp, setWorkExp] = useState([{ employer:'', role:'', from:'', to:'', description:'', current:false }]);

  // Step 6 - Subjects & Levels
  const [allSubjects, setAllSubjects]     = useState([]);
  const [subjectSearch, setSubjectSearch] = useState('');
  const [selSubjects, setSelSubjects]     = useState([]);
  const [selLevels, setSelLevels]         = useState([]);

  // Step 7 - ID
  const [idType, setIdType] = useState('passport');
  const [idFile, setIdFile] = useState(null);

  // Step 8 - DBS
  const [hasDbs, setHasDbs]   = useState(false);
  const [dbsFile, setDbsFile] = useState(null);
  const [dbsNum, setDbsNum]   = useState('');
  const [dbsDate, setDbsDate] = useState('');

  // Step 9 - References
  const [refs, setRefs] = useState([
    { name:'', email:'', phone:'', relationship:'' },
    { name:'', email:'', phone:'', relationship:'' },
  ]);

  // Step 10 - Availability
  const [slots, setSlots]   = useState([]);
  const [notice, setNotice] = useState(24);

  useEffect(() => {
    Promise.all([
      api.get('/onboarding/progress'),
      api.get('/search/subjects'),
    ]).then(([prog, subs]) => {
      setAllSubjects(subs.data.subjects || []);
      const p = prog.data.progress;
      if (p) {
        if (!p.step_fee_paid)          setStep(2);
        else if (!p.step_english_test) setStep(3);
        else if (!p.step_bio_video)    setStep(4);
        else if (p.current_step === 5) setStep(5);
        else if (!p.step_specialisms)  setStep(6);
        else if (!p.step_id_upload)    setStep(7);
        else if (!p.step_dbs)          setStep(8);
        else if (!p.step_references)   setStep(9);
        else if (!p.step_availability) setStep(10);
        else if (!p.step_submitted)    setStep(11);
        else { navigate('/tutor/dashboard'); return; }
      }
    }).catch(()=>{}).finally(()=>setLoading(false));
  }, []);

  const filteredSubjects = allSubjects.filter(s =>
    s.name.toLowerCase().includes(subjectSearch.toLowerCase())
  );

  const toggleSubject = (id) => {
    if (selSubjects.includes(id)) setSelSubjects(selSubjects.filter(x=>x!==id));
    else if (selSubjects.length < 10) setSelSubjects([...selSubjects, id]);
  };

  const toggleLevel = (id) => {
    setSelLevels(prev => prev.includes(id) ? prev.filter(x=>x!==id) : [...prev, id]);
  };

  const toggleSlot = (day, time) => {
    const exists = slots.find(s=>s.day_of_week===day&&s.start_time===time+':00');
    if (exists) setSlots(slots.filter(s=>!(s.day_of_week===day&&s.start_time===time+':00')));
    else {
      const endH = parseInt(time)+1;
      setSlots([...slots, { day_of_week:day, start_time:time+':00', end_time:String(endH).padStart(2,'0')+':00:00' }]);
    }
  };

  const isSelected = (day, time) => slots.some(s=>s.day_of_week===day&&s.start_time===time+':00');

  const addWork = () => setWorkExp([...workExp, { employer:'', role:'', from:'', to:'', description:'', current:false }]);
  const removeWork = (i) => setWorkExp(workExp.filter((_,idx)=>idx!==i));
  const updateWork = (i, f, v) => { const u=[...workExp]; u[i]={...u[i],[f]:v}; setWorkExp(u); };

  const handleStep = async (s) => {
    setSaving(true); setError('');
    try {
      if (s === 2) {
        await api.post('/onboarding/fee/skip');
        setStep(3);

      } else if (s === 3) {
        if (!englishVideo) throw new Error('Please upload your English video');
        const fd = new FormData();
        fd.append('video', englishVideo);
        await api.post('/onboarding/english-test', fd, { headers:{'Content-Type':'multipart/form-data'} });
        setStep(4);

      } else if (s === 4) {
        if (!bio.trim()) throw new Error('Please write a bio');
        if (!qualifications.trim()) throw new Error('Please add your qualifications');
        const fd = new FormData();
        fd.append('bio', bio);
        fd.append('qualifications', qualifications);
        for (const f of eduDocs) fd.append('documents', f);
        await api.post('/onboarding/profile-details', fd, { headers:{'Content-Type':'multipart/form-data'} });
        setStep(5);

      } else if (s === 5) {
        const valid = workExp.filter(w=>w.employer&&w.role);
        await api.post('/onboarding/work-experience', { work_experience: valid });
        setStep(6);

      } else if (s === 6) {
        if (!selSubjects.length) throw new Error('Please select at least one subject');
        if (!selLevels.length) throw new Error('Please select at least one teaching standard');
        await api.post('/onboarding/specialisms', { subjects: selSubjects, levels: selLevels, age_groups: [1,2,3,4,5] });
        setStep(7);

      } else if (s === 7) {
        if (!idFile) throw new Error('Please upload your ID document');
        const fd = new FormData();
        fd.append('documents', idFile);
        fd.append('document_type', idType);
        await api.post('/onboarding/id', fd, { headers:{'Content-Type':'multipart/form-data'} });
        setStep(8);

      } else if (s === 8) {
        const fd = new FormData();
        fd.append('has_dbs', hasDbs);
        if (hasDbs && dbsFile) fd.append('documents', dbsFile);
        if (dbsNum) fd.append('certificate_number', dbsNum);
        if (dbsDate) fd.append('issue_date', dbsDate);
        await api.post('/onboarding/dbs', fd, { headers:{'Content-Type':'multipart/form-data'} });
        setStep(9);

      } else if (s === 9) {
        if (!refs[0].name||!refs[0].email||!refs[1].name||!refs[1].email)
          throw new Error('Please fill in both references');
        await api.post('/onboarding/references', { references: refs });
        setStep(10);

      } else if (s === 10) {
        if (!slots.length) throw new Error('Please add at least one availability slot');
        await api.post('/onboarding/availability', { slots, notice_period_hours: notice });
        setStep(11);

      } else if (s === 11) {
        await api.post('/onboarding/submit');
        navigate('/tutor/dashboard');
      }
    } catch (err) {
      setError(err.response?.data?.message || err.message);
    }
    setSaving(false);
  };

  if (loading) return <div className="loading-screen"><div className="spinner spinner-lg"/></div>;

  const groupedLevels = LEVELS.reduce((acc, l) => {
    if (!acc[l.group]) acc[l.group] = [];
    acc[l.group].push(l);
    return acc;
  }, {});

  const btnRow = (backStep) => (
    <div style={{display:'flex',gap:12,marginTop:24}}>
      {backStep && <button className="btn btn-ghost" onClick={()=>setStep(backStep)}>Back</button>}
      <button className="btn btn-primary" style={{flex:1}} onClick={()=>handleStep(step)} disabled={saving}>
        {saving ? 'Saving...' : step===11 ? 'Submit application' : 'Continue'}
      </button>
    </div>
  );

  return (
    <div style={{minHeight:'100vh',background:'linear-gradient(150deg,#edfaf3 0%,#f5fdf9 100%)',padding:'32px 16px'}}>
      <div style={{maxWidth:720,margin:'0 auto'}}>
        <div style={{textAlign:'center',marginBottom:28}}>
          <span style={{fontWeight:800,fontSize:'1.2rem',color:'#052e1c'}}>Budget<span style={{color:'#22c97f'}}>Tutor</span></span>
          <p style={{color:'var(--ink-400)',fontSize:'0.85rem',marginTop:4}}>Tutor application — Step {step} of {STEPS.length}</p>
        </div>

        <div className="card card-elevated" style={{padding:36}}>
          <Stepper current={step}/>
          {error && <div className="alert alert-error" style={{marginBottom:20}}>{error}</div>}

          {/* STEP 2 — Access Fee */}
          {step===2 && (
            <div>
              <h2 style={{marginBottom:4}}>Platform access fee</h2>
              <p style={{color:'var(--ink-400)',marginBottom:24}}>One-off, non-refundable payment to join</p>
              <div style={{background:'var(--green-50)',border:'1.5px solid var(--green-200)',borderRadius:12,padding:'16px 18px',marginBottom:24}}>
                <strong style={{color:'var(--green-800)'}}>One-off access fee: £1.00 / $1.00</strong>
                <p style={{margin:'4px 0 0',fontSize:'0.82rem',color:'var(--green-800)'}}>Non-refundable. Covers the cost of our manual vetting process.</p>
              </div>
              <button className="btn btn-primary btn-full btn-lg" onClick={()=>handleStep(2)} disabled={saving}>
                {saving ? 'Processing...' : 'Continue'}
              </button>
            </div>
          )}

          {/* STEP 3 — English Video */}
          {step===3 && (
            <div>
              <h2 style={{marginBottom:4}}>English language video</h2>
              <p style={{color:'var(--ink-400)',marginBottom:8}}>Record a short video (max 30 seconds) introducing yourself clearly in English.</p>
              <div className="alert alert-info" style={{marginBottom:20}}>
                Say your name, what subjects you teach, and why you enjoy tutoring. This helps us verify your spoken English.
              </div>
              <div style={{border:'2px dashed var(--green-300)',borderRadius:12,padding:28,textAlign:'center',background:'var(--green-50)',cursor:'pointer'}}
                onClick={()=>document.getElementById('eng-video').click()}>
                {englishVideo
                  ? <div>
                      <div style={{fontSize:'2rem',marginBottom:8}}>✅</div>
                      <p style={{margin:0,fontWeight:600,color:'var(--green-800)'}}>{englishVideo.name}</p>
                      <p style={{margin:'4px 0 0',fontSize:'0.78rem',color:'var(--green-600)'}}>({(englishVideo.size/1024/1024).toFixed(1)}MB) — click to change</p>
                    </div>
                  : <>
                      <div style={{fontSize:'2.5rem',marginBottom:8}}>🎥</div>
                      <p style={{fontWeight:600,color:'var(--green-800)',margin:'0 0 4px'}}>Click to upload your video</p>
                      <p style={{fontSize:'0.8rem',color:'var(--ink-400)',margin:0}}>MP4, MOV, WebM · Max 30 seconds · Max 25MB</p>
                    </>
                }
                <input id="eng-video" type="file" accept="video/*" style={{display:'none'}} onChange={e=>setEnglishVideo(e.target.files[0])}/>
              </div>
              {btnRow(2)}
            </div>
          )}

          {/* STEP 4 — Bio & Qualifications */}
          {step===4 && (
            <div>
              <h2 style={{marginBottom:4}}>About you</h2>
              <p style={{color:'var(--ink-400)',marginBottom:24}}>Tell parents about yourself and your qualifications</p>

              <div className="form-group">
                <label className="form-label">Bio <span style={{color:'var(--error)'}}>*</span></label>
                <textarea className="form-textarea" rows={5} value={bio} onChange={e=>setBio(e.target.value)}
                  placeholder="Tell parents about your teaching experience, approach and what makes you a great tutor..."/>
                <div style={{fontSize:'0.75rem',color:'var(--ink-300)',textAlign:'right'}}>{bio.length} characters</div>
              </div>

              <div className="form-group">
                <label className="form-label">Qualifications <span style={{color:'var(--error)'}}>*</span></label>
                <textarea className="form-textarea" rows={4} value={qualifications} onChange={e=>setQuals(e.target.value)}
                  placeholder="e.g. BSc Mathematics, University of Manchester (2018)&#10;PGCE Secondary Education (2019)&#10;Qualified Teacher Status (QTS)"/>
              </div>

              <div className="form-group">
                <label className="form-label">Educational documents (optional)</label>
                <p style={{fontSize:'0.8rem',color:'var(--ink-400)',marginBottom:8}}>Upload degree certificates, teaching qualifications etc. PDF or images only, max 5 files.</p>
                <div style={{border:'2px dashed var(--ink-200)',borderRadius:12,padding:24,textAlign:'center',cursor:'pointer',background:'var(--ink-50)'}}
                  onClick={()=>document.getElementById('edu-docs').click()}>
                  {eduDocs.length > 0
                    ? <div>
                        {eduDocs.map((f,i)=>(
                          <div key={i} style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'6px 10px',background:'var(--green-50)',borderRadius:6,marginBottom:4}}>
                            <span style={{fontSize:'0.82rem',fontWeight:600,color:'var(--green-800)'}}>{f.name}</span>
                            <button type="button" onClick={e=>{e.stopPropagation();setEduDocs(eduDocs.filter((_,idx)=>idx!==i));}}
                              style={{background:'none',border:'none',cursor:'pointer',color:'var(--error)',fontWeight:700}}>x</button>
                          </div>
                        ))}
                        <p style={{fontSize:'0.78rem',color:'var(--ink-400)',marginTop:8,marginBottom:0}}>Click to add more</p>
                      </div>
                    : <>
                        <div style={{fontSize:'2rem',marginBottom:8}}>📄</div>
                        <p style={{fontWeight:600,margin:'0 0 4px'}}>Click to upload documents</p>
                        <p style={{fontSize:'0.78rem',color:'var(--ink-400)',margin:0}}>PDF, JPG, PNG · Max 10MB each</p>
                      </>
                  }
                  <input id="edu-docs" type="file" accept="image/*,.pdf" multiple style={{display:'none'}}
                    onChange={e=>setEduDocs([...eduDocs,...Array.from(e.target.files)].slice(0,5))}/>
                </div>
              </div>
              {btnRow(3)}
            </div>
          )}

          {/* STEP 5 — Work Experience */}
          {step===5 && (
            <div>
              <h2 style={{marginBottom:4}}>Work experience</h2>
              <p style={{color:'var(--ink-400)',marginBottom:24}}>Add your teaching or relevant work experience. Add as many entries as you like.</p>

              {workExp.map((exp,i)=>(
                <div key={i} style={{border:'1.5px solid var(--ink-100)',borderRadius:12,padding:20,marginBottom:16,background:'var(--ink-50)'}}>
                  <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:14}}>
                    <strong style={{fontSize:'0.9rem'}}>Experience {i+1}</strong>
                    {workExp.length > 1 && (
                      <button type="button" onClick={()=>removeWork(i)}
                        style={{background:'#fee2e2',border:'none',borderRadius:6,padding:'4px 10px',cursor:'pointer',color:'var(--error)',fontWeight:700,fontSize:'0.78rem'}}>
                        Remove
                      </button>
                    )}
                  </div>
                  <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
                    <div className="form-group" style={{margin:0}}>
                      <label className="form-label">Employer / School <span style={{color:'var(--error)'}}>*</span></label>
                      <input type="text" className="form-input" value={exp.employer} onChange={e=>updateWork(i,'employer',e.target.value)} placeholder="e.g. St Mary's Secondary School"/>
                    </div>
                    <div className="form-group" style={{margin:0}}>
                      <label className="form-label">Job title <span style={{color:'var(--error)'}}>*</span></label>
                      <input type="text" className="form-input" value={exp.role} onChange={e=>updateWork(i,'role',e.target.value)} placeholder="e.g. Maths Teacher"/>
                    </div>
                    <div className="form-group" style={{margin:0}}>
                      <label className="form-label">From</label>
                      <input type="month" className="form-input" value={exp.from} onChange={e=>updateWork(i,'from',e.target.value)}/>
                    </div>
                    <div className="form-group" style={{margin:0}}>
                      <label className="form-label">To</label>
                      <input type="month" className="form-input" value={exp.to} onChange={e=>updateWork(i,'to',e.target.value)} disabled={exp.current}/>
                      <label style={{display:'flex',alignItems:'center',gap:6,marginTop:6,cursor:'pointer',fontSize:'0.8rem'}}>
                        <input type="checkbox" checked={exp.current} onChange={e=>updateWork(i,'current',e.target.checked)} style={{accentColor:'#22c97f'}}/>
                        Currently working here
                      </label>
                    </div>
                  </div>
                  <div className="form-group" style={{margin:'12px 0 0'}}>
                    <label className="form-label">Description</label>
                    <textarea className="form-textarea" rows={2} value={exp.description} onChange={e=>updateWork(i,'description',e.target.value)}
                      placeholder="Brief description of your responsibilities..."/>
                  </div>
                </div>
              ))}

              <button type="button" className="btn btn-secondary btn-full" onClick={addWork} style={{marginBottom:20}}>
                + Add another experience
              </button>
              {btnRow(4)}
            </div>
          )}

          {/* STEP 6 — Subjects & Standards */}
          {step===6 && (
            <div>
              <h2 style={{marginBottom:4}}>Subjects and teaching standards</h2>
              <p style={{color:'var(--ink-400)',marginBottom:24}}>Select up to 10 subjects and tick which levels you teach</p>

              <div className="form-group">
                <label className="form-label">Subjects you teach <span style={{color:'var(--error)'}}>*</span></label>
                <p style={{fontSize:'0.8rem',color:'var(--ink-400)',marginBottom:8}}>{selSubjects.length}/10 selected</p>
                <input type="text" className="form-input" placeholder="Search subjects..." value={subjectSearch}
                  onChange={e=>setSubjectSearch(e.target.value)} style={{marginBottom:8}}/>

                {selSubjects.length > 0 && (
                  <div style={{display:'flex',flexWrap:'wrap',gap:6,marginBottom:10,padding:'10px 12px',background:'var(--green-50)',borderRadius:8,border:'1.5px solid var(--green-200)'}}>
                    {selSubjects.map(id=>{
                      const s = allSubjects.find(x=>x.id===id);
                      return s ? (
                        <span key={id} style={{display:'inline-flex',alignItems:'center',gap:6,background:'#22c97f',color:'#fff',borderRadius:16,padding:'4px 12px',fontSize:'0.8rem',fontWeight:600}}>
                          {s.name}
                          <button type="button" onClick={()=>toggleSubject(id)} style={{background:'none',border:'none',cursor:'pointer',color:'#fff',fontWeight:800,fontSize:'1rem',lineHeight:1}}>x</button>
                        </span>
                      ) : null;
                    })}
                  </div>
                )}

                <div style={{maxHeight:220,overflowY:'auto',border:'1.5px solid var(--ink-100)',borderRadius:10}}>
                  {filteredSubjects.map(s=>(
                    <div key={s.id} onClick={()=>toggleSubject(s.id)} style={{
                      display:'flex',alignItems:'center',gap:10,padding:'10px 14px',cursor:'pointer',
                      background: selSubjects.includes(s.id) ? 'var(--green-50)' : 'transparent',
                      borderBottom:'1px solid var(--ink-50)',
                      opacity: !selSubjects.includes(s.id) && selSubjects.length>=10 ? 0.4 : 1
                    }}>
                      <div style={{
                        width:18,height:18,borderRadius:4,border:'2px solid',flexShrink:0,
                        borderColor: selSubjects.includes(s.id) ? '#22c97f' : 'var(--ink-200)',
                        background: selSubjects.includes(s.id) ? '#22c97f' : 'transparent',
                        display:'flex',alignItems:'center',justifyContent:'center'
                      }}>
                        {selSubjects.includes(s.id) && <span style={{color:'#fff',fontSize:'0.7rem',fontWeight:800}}>✓</span>}
                      </div>
                      <span style={{fontSize:'0.875rem'}}>{s.name}</span>
                    </div>
                  ))}
                  {filteredSubjects.length===0 && <div style={{padding:16,textAlign:'center',color:'var(--ink-400)',fontSize:'0.875rem'}}>No subjects found</div>}
                </div>
              </div>

              <div className="form-group" style={{marginTop:24}}>
                <label className="form-label">Teaching standards <span style={{color:'var(--error)'}}>*</span></label>
                <p style={{fontSize:'0.8rem',color:'var(--ink-400)',marginBottom:12}}>Tick all levels you are comfortable teaching</p>
                {Object.entries(groupedLevels).map(([group,lvls])=>(
                  <div key={group} style={{marginBottom:16}}>
                    <p style={{fontSize:'0.78rem',fontWeight:700,color:'var(--ink-400)',textTransform:'uppercase',letterSpacing:'0.05em',marginBottom:8}}>{group}</p>
                    <div style={{display:'flex',flexDirection:'column',gap:6}}>
                      {lvls.map(l=>(
                        <div key={l.id} onClick={()=>toggleLevel(l.id)} style={{
                          display:'flex',alignItems:'center',gap:12,padding:'12px 16px',borderRadius:10,cursor:'pointer',
                          background: selLevels.includes(l.id) ? 'var(--green-50)' : 'var(--ink-50)',
                          border:'1.5px solid '+(selLevels.includes(l.id)?'var(--green-400)':'var(--ink-100)'),
                        }}>
                          <div style={{
                            width:20,height:20,borderRadius:4,border:'2px solid',flexShrink:0,
                            borderColor: selLevels.includes(l.id) ? '#22c97f' : 'var(--ink-200)',
                            background: selLevels.includes(l.id) ? '#22c97f' : 'transparent',
                            display:'flex',alignItems:'center',justifyContent:'center'
                          }}>
                            {selLevels.includes(l.id) && <span style={{color:'#fff',fontSize:'0.75rem',fontWeight:800}}>✓</span>}
                          </div>
                          <span style={{fontWeight:selLevels.includes(l.id)?700:500,fontSize:'0.875rem'}}>{l.name}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
              {btnRow(5)}
            </div>
          )}

          {/* STEP 7 — ID Upload */}
          {step===7 && (
            <div>
              <h2 style={{marginBottom:4}}>Photo ID</h2>
              <p style={{color:'var(--ink-400)',marginBottom:24}}>Upload a clear photo of your passport, driving licence or national ID</p>
              <div className="form-group">
                <label className="form-label">Document type</label>
                <select className="form-select" value={idType} onChange={e=>setIdType(e.target.value)}>
                  <option value="passport">Passport</option>
                  <option value="driving_licence">Driving licence</option>
                  <option value="national_id">National ID</option>
                </select>
              </div>
              <div style={{border:'2px dashed var(--ink-200)',borderRadius:12,padding:28,textAlign:'center',cursor:'pointer',background:'var(--ink-50)'}}
                onClick={()=>document.getElementById('id-doc').click()}>
                {idFile
                  ? <p style={{margin:0,fontWeight:600,color:'var(--green-800)'}}>✓ {idFile.name}</p>
                  : <>
                      <div style={{fontSize:'2.5rem',marginBottom:8}}>🪪</div>
                      <p style={{fontWeight:600,margin:'0 0 4px'}}>Upload your ID document</p>
                      <p style={{fontSize:'0.8rem',color:'var(--ink-400)',margin:0}}>JPG, PNG or PDF · Max 10MB</p>
                    </>
                }
                <input id="id-doc" type="file" accept="image/*,.pdf" style={{display:'none'}} onChange={e=>setIdFile(e.target.files[0])}/>
              </div>
              {btnRow(6)}
            </div>
          )}

          {/* STEP 8 — DBS */}
          {step===8 && (
            <div>
              <h2 style={{marginBottom:4}}>DBS certificate</h2>
              <p style={{color:'var(--ink-400)',marginBottom:24}}>Not required but displayed on your profile as a trust signal</p>
              <div onClick={()=>setHasDbs(!hasDbs)} style={{
                display:'flex',alignItems:'center',gap:12,padding:'14px 16px',borderRadius:10,border:'1.5px solid',
                borderColor:hasDbs?'var(--green-400)':'var(--ink-100)',background:hasDbs?'var(--green-50)':'var(--ink-50)',
                marginBottom:16,cursor:'pointer'
              }}>
                <div style={{width:20,height:20,borderRadius:4,border:'2px solid',borderColor:hasDbs?'#22c97f':'var(--ink-200)',background:hasDbs?'#22c97f':'transparent',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                  {hasDbs && <span style={{color:'#fff',fontSize:'0.75rem',fontWeight:800}}>✓</span>}
                </div>
                <span style={{fontWeight:600}}>I have a valid DBS certificate</span>
              </div>
              {hasDbs && (
                <div>
                  <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:14}}>
                    <div className="form-group" style={{margin:0}}>
                      <label className="form-label">Certificate number</label>
                      <input type="text" className="form-input" value={dbsNum} onChange={e=>setDbsNum(e.target.value)} placeholder="001234567890"/>
                    </div>
                    <div className="form-group" style={{margin:0}}>
                      <label className="form-label">Issue date</label>
                      <input type="date" className="form-input" value={dbsDate} onChange={e=>setDbsDate(e.target.value)}/>
                    </div>
                  </div>
                  <div style={{border:'2px dashed var(--ink-200)',borderRadius:12,padding:20,textAlign:'center',cursor:'pointer'}}
                    onClick={()=>document.getElementById('dbs-doc').click()}>
                    {dbsFile ? <p style={{margin:0,fontWeight:600}}>✓ {dbsFile.name}</p> : <p style={{margin:0,color:'var(--ink-400)'}}>Upload certificate (optional)</p>}
                    <input id="dbs-doc" type="file" accept="image/*,.pdf" style={{display:'none'}} onChange={e=>setDbsFile(e.target.files[0])}/>
                  </div>
                </div>
              )}
              {btnRow(7)}
            </div>
          )}

          {/* STEP 9 — References */}
          {step===9 && (
            <div>
              <h2 style={{marginBottom:4}}>References</h2>
              <p style={{color:'var(--ink-400)',marginBottom:24}}>Two professional or academic references. We will contact them to verify.</p>
              {refs.map((ref,i)=>(
                <div key={i} style={{padding:16,borderRadius:12,border:'1.5px solid var(--ink-100)',marginBottom:16,background:'var(--ink-50)'}}>
                  <p style={{fontWeight:700,margin:'0 0 12px',fontSize:'0.9rem'}}>Reference {i+1}</p>
                  <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10}}>
                    <div className="form-group" style={{margin:0}}>
                      <label className="form-label">Full name <span style={{color:'var(--error)'}}>*</span></label>
                      <input type="text" className="form-input" value={ref.name} onChange={e=>{const r=[...refs];r[i]={...r[i],name:e.target.value};setRefs(r);}}/>
                    </div>
                    <div className="form-group" style={{margin:0}}>
                      <label className="form-label">Email <span style={{color:'var(--error)'}}>*</span></label>
                      <input type="email" className="form-input" value={ref.email} onChange={e=>{const r=[...refs];r[i]={...r[i],email:e.target.value};setRefs(r);}}/>
                    </div>
                    <div className="form-group" style={{margin:0}}>
                      <label className="form-label">Phone</label>
                      <input type="tel" className="form-input" value={ref.phone} onChange={e=>{const r=[...refs];r[i]={...r[i],phone:e.target.value};setRefs(r);}}/>
                    </div>
                    <div className="form-group" style={{margin:0}}>
                      <label className="form-label">Relationship</label>
                      <input type="text" className="form-input" value={ref.relationship} placeholder="e.g. Line manager" onChange={e=>{const r=[...refs];r[i]={...r[i],relationship:e.target.value};setRefs(r);}}/>
                    </div>
                  </div>
                </div>
              ))}
              {btnRow(8)}
            </div>
          )}

          {/* STEP 10 — Availability */}
          {step===10 && (
            <div>
              <h2 style={{marginBottom:4}}>Your availability</h2>
              <p style={{color:'var(--ink-400)',marginBottom:20}}>Click time slots when you are available to teach</p>
              <div className="form-group" style={{marginBottom:20}}>
                <label className="form-label">Minimum booking notice</label>
                <select className="form-select" value={notice} onChange={e=>setNotice(parseInt(e.target.value))}>
                  <option value={24}>24 hours</option>
                  <option value={48}>48 hours</option>
                  <option value={72}>72 hours</option>
                </select>
              </div>
              <div style={{overflowX:'auto'}}>
                <table style={{width:'100%',borderCollapse:'separate',borderSpacing:3,minWidth:480}}>
                  <thead>
                    <tr>
                      <th style={{fontSize:'0.72rem',padding:'6px 8px',fontWeight:700,color:'var(--ink-400)',textAlign:'left',minWidth:52}}>Time</th>
                      {DAYS.map(d=><th key={d} style={{fontSize:'0.72rem',padding:'6px 4px',fontWeight:700,color:'var(--ink-400)',textAlign:'center',minWidth:52}}>{d.slice(0,3)}</th>)}
                    </tr>
                  </thead>
                  <tbody>
                    {TIMES.map(time=>(
                      <tr key={time}>
                        <td style={{fontSize:'0.72rem',color:'var(--ink-400)',padding:'3px 8px',whiteSpace:'nowrap'}}>{time}</td>
                        {DAYS.map((_,day)=>(
                          <td key={day} style={{padding:2}}>
                            <button type="button" onClick={()=>toggleSlot(day,time)} style={{
                              width:'100%',height:26,borderRadius:6,border:'none',cursor:'pointer',
                              background:isSelected(day,time)?'#22c97f':'#f4faf7',
                              boxShadow:isSelected(day,time)?'0 2px 6px rgba(34,201,127,0.3)':'none'
                            }}/>
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <p style={{marginTop:10,fontSize:'0.78rem',color:'var(--ink-300)'}}>{slots.length} slot{slots.length!==1?'s':''} selected</p>
              {btnRow(9)}
            </div>
          )}

          {/* STEP 11 — Submit */}
          {step===11 && (
            <div>
              <h2 style={{marginBottom:4}}>Submit your application</h2>
              <p style={{color:'var(--ink-400)',marginBottom:24}}>Everything looks good. Our team will review within 48 hours.</p>
              <div style={{background:'var(--green-50)',borderRadius:12,padding:20,border:'1.5px solid var(--green-200)',marginBottom:20}}>
                {['Account created','Platform fee','English video','Bio and qualifications','Work experience','Subjects and standards','ID document','DBS declaration','References','Availability'].map(label=>(
                  <div key={label} style={{display:'flex',gap:10,padding:'7px 0',borderBottom:'1px solid var(--green-200)',fontSize:'0.875rem'}}>
                    <span style={{color:'var(--green-600)',fontWeight:700}}>✓</span>
                    <span style={{fontWeight:600,color:'var(--green-800)'}}>{label}</span>
                  </div>
                ))}
              </div>
              <div className="alert alert-info" style={{marginBottom:20}}>
                Our team reviews all applications within 48 hours. You will be notified once approved.
              </div>
              {btnRow(10)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
